"use client"

import HomeDetailsWrapperAccordion from "@/features/homeowners/components/home-details-wrapper-accordion"
import { residentTypeOptions, residenceTypeOptions, structureTypeOptions, canBeHomeRepairedOptions, isNewHousingHelpNeededOptions, buildingHeightOptions, potentialStructuralProblemsOptions, heightOfWaterOptions, isHomeRepairedOptions } from "../../constants/options"
import FormTextInput from "@/shared/components/form-inputs/form-text-input"
import FormSelectInput from "../../../../shared/components/form-inputs/form-select-input"
import FormTextareaInput from "../../../../shared/components/form-inputs/form-textarea-input"
import FormPhoneInput from "@/shared/components/form-inputs/form-phone-input"
import FormYesNoInput from "../../../../shared/components/form-inputs/form-yes-no-input"
import { SchemaType } from "@/shared/types/helpers.type"
import { HomeWithHomeOwnerFormType } from "../../schema/home-with-home-owner.schema"
import { useFormContext } from "react-hook-form"
import FormRadioInput from "@/shared/components/form-inputs/form-radio-input"

const baseFieldName = "home.repairabilityInfo"

type RegisterHomeTypeFormProps = {
    hideAssessorName?: boolean // Optionally hide "Name of Person Completing Form" field
}

function RegisterHomeTypeForm({ hideAssessorName = false }: RegisterHomeTypeFormProps) {
    const { control } = useFormContext<HomeWithHomeOwnerFormType>()
    return (
        <HomeDetailsWrapperAccordion heading="Home Type & Repairability Info">
            <FormSelectInput
                inputGroupProps={{
                    label: "Residence Type",
                }}
                options={residenceTypeOptions}
                name={`${baseFieldName}.residenceType`}
                control={control}
            />
            {!hideAssessorName && (
                <FormTextInput
                    inputGroupProps={{
                        label: "Name of Person Completing Form",
                    }}
                    placeholder="Name of Person Completing Form"
                    name={`${baseFieldName}.assessorName`}
                    control={control}
                />
            )}
            <FormSelectInput
                inputGroupProps={{
                    label: "Structure Type",
                }}
                options={structureTypeOptions}
                name={`${baseFieldName}.structureType`}
                control={control}
            />
            {/* row 3 */}
            <FormTextInput
                inputGroupProps={{
                    label: "Owner Name (if rental)",
                }}
                placeholder="Owner Name"
                name={`${baseFieldName}.ownerNameIfRental`}
                control={control}
            />
            <FormPhoneInput
                inputGroupProps={{
                    label: "Owner Phone Number (if rental)",
                }}
                placeholder="Owner Phone Number"
                name={`${baseFieldName}.ownerPhoneNumberIfRental`}
                type={SchemaType.phone}
                control={control}
            />

            <FormYesNoInput
                inputGroupProps={{
                    label: "Is help needed with Rebuilding?"
                }}
                name={`${baseFieldName}.rebuildingHelpNeeded`}
                control={control}
            />
            {/* Put these two in one row */}
            <FormSelectInput
                inputGroupProps={{
                    label: "Can the home be repaired?",
                }}
                options={isHomeRepairedOptions}
                name={`${baseFieldName}.canBeRepaired`}
                control={control}
            />

            <FormSelectInput
                inputGroupProps={{
                    label: "Is New Housing/New Construction help needed?",
                }}
                options={isNewHousingHelpNeededOptions}
                name={`${baseFieldName}.newHousingHelpNeeded`}
                control={control}
            />
            <FormSelectInput
                inputGroupProps={{
                    label: "Height of Water in Home",
                }}
                options={heightOfWaterOptions}
                name={`${baseFieldName}.heightOfWater`}
                control={control}
            />
            <FormYesNoInput
                inputGroupProps={{
                    label: "Permission to have Work When Gone?",
                }}
                name="home.homeStatusInfo.permissionToWork"
                control={control}
            />


            <FormYesNoInput
                inputGroupProps={{
                    label: "Is help needed with Rebuilding supplies and materials?"
                }}
                name={`${baseFieldName}.rebuildingSuppliesHelpNeeded`}
                control={control}
            />



            <FormYesNoInput
                inputGroupProps={{
                    label: "Are There dogs in the home?"
                }}
                name="home.dogsInHome"
                control={control}
            />
            <FormSelectInput
                inputGroupProps={{
                    label: "What is the building height?",
                }}
                options={buildingHeightOptions}
                name={`${baseFieldName}.buildingHeight`}
                control={control}
            />
            <FormTextInput
                inputGroupProps={{
                    label: "What is the approx square feet of affected area of home?",
                }}
                placeholder="What is the approx square feet of affected area of home?"
                name={`${baseFieldName}.affectedSquareFeet`}
                type={"number"}
                control={control}
            />
            <FormSelectInput
                inputGroupProps={{
                    label: "Are there potential structural problems with the house?",
                }}
                options={potentialStructuralProblemsOptions}
                name={`${baseFieldName}.potentialStructuralProblems`}
                control={control}
            />

            <FormTextareaInput
                inputGroupProps={{ label: "Please share anything you feel comfortable about how the storm has affected your home or daily life. This helps us connect you with resources and support. No details are required.", wrapperClassName: "three-cols" }}
                rows={4}
                name="homeOwner.ownerStory"
                control={control}
            />


        </HomeDetailsWrapperAccordion>
    )
}

export default RegisterHomeTypeForm
